import React, { useEffect, useState } from 'react';
import { Modal, Button, Input } from '../../../../components/common';

interface Props {
  cycle: { id: string; name: string; openOkrs: number } | null;
  isClosing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Replaces window.confirm (whose text wrongly said "completed"). Spec §5. */
export const CloseCycleModal: React.FC<Props> = ({ cycle, isClosing, onConfirm, onCancel }) => {
  const [typed, setTyped] = useState('');
  useEffect(() => setTyped(''), [cycle?.id]);
  if (!cycle) return null;
  // Names are stored untrimmed, so a stored name with a trailing/leading space
  // (e.g. "Q3 2026 ") would otherwise never match what a person types.
  const matches = typed.trim() === cycle.name.trim();
  return (
    <Modal isOpen onClose={onCancel} title={`Close "${cycle.name}"?`}>
      <ul className="list-disc pl-5 space-y-1 text-sm text-stone-700">
        <li>{cycle.openOkrs} open OKRs will be closed.</li>
        <li>Check-ins and edits stop.</li>
        <li>You can reopen it within 30 days.</li>
      </ul>
      <label className="block mt-4 text-sm text-stone-700" htmlFor="close-cycle-name">
        Type <strong className="font-semibold text-stone-900 select-all">{cycle.name.trim()}</strong> to confirm
      </label>
      <Input id="close-cycle-name" value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" />
      <div className="flex justify-end gap-2 mt-6">
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" disabled={!matches || isClosing} onClick={onConfirm}>Close cycle</Button>
      </div>
    </Modal>
  );
};
